module.exports = __webpack_public_path__ + "static/media/image-card-4.fb232b20.png";